import image from "@irati-web/recognition/src/images/reward-empty.png"
import styled from "styled-components"
import {greys} from "@irati/ui/src/global/colors"
import {Card} from "@irati/ui/src/Layout"
import {Para} from "@irati/ui/src/Labels"

const ICON_SIZE = 120

export const RewardIcon = styled.img.attrs({
  alt: "reward",
  width: `${ICON_SIZE}px`,
  height: `${ICON_SIZE}px`,
  src: image
})`
  margin-bottom: 30px;
  border-radius: 50%;
  overflow:hidden;
`

export const Wrapper = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  border: none;
`

export const Paragraph = styled(Para)`
  max-width: 200px;
  text-align: center;
  margin-bottom: 30px;
  color: ${greys.medium};
`
